module.exports = __webpack_public_path__ + "assets/img/img238.3e1f537b.png";